import { CartModal } from "components/CartModal/CartModal";
import { Button } from "components/DesignSystem/Button/Button";
import { CartPaymentIcon } from "components/icons/CartPaymentIcon";
import { RightArrow } from "components/icons/RightArrow";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { TaxActionItemType } from "store/apis/actionItems";
import { ActionItemEntitySelector } from "./ActionItemEntitySelector";
import { useState } from "react";
import { Entity } from "types/Models/entity";

export const CartActionItem = ({
  item,
  groupIdFromProps,
}: {
  item: TaxActionItemType;
  groupIdFromProps?: string;
}) => {
  const cartPayment = useModal();
  const entitySelector = useModal();
  const [selectedEntity, setSelectedEntity] = useState<string | null>(null);
  const { entities } = useCurrentGroupContext();

  const handleEntitySelect = (entityId: string) => {
    setSelectedEntity(entityId);
    entitySelector.close();
    cartPayment.open();
  };

  const handleClose = () => {
    cartPayment.close();
    setSelectedEntity(null);
  };

  return (
    <>
      <div
        className="t-flex t-justify-between t-items-center t-py-4 t-px-2 t-border t-border-solid t-border-neutral-0 t-border-t-surface-transparent t-border-l-surface-transparent t-border-r-surface-transparent t-group active:t-border-purple active:t-border-t-purple active:t-border-r-purple active:t-border-l-purple t-rounded-lg hover:t-bg-surface-lighter-grey"
        onClick={item.ids.length > 1 ? entitySelector.open : cartPayment.open}
        role="button"
      >
        <div className="t-flex t-gap-2 t-items-center">
          <div className="t-relative t-min-h-10 t-min-w-10 t-max-h-10 t-max-w-10 t-rounded-full t-flex t-items-center t-justify-center t-bg-surface-lighter-grey">
            <CartPaymentIcon />
          </div>
          <div>
            <div className="t-text-subtext t-text-text-100">{item.title}</div>
            <div className="t-text-body-sm t-text-text-30">{item.subtitle}</div>
          </div>
        </div>
        <Button size="small" customType="text">
          <div className="t-text-text-60 group-hover:t-hidden t-block">
            <RightArrow />
          </div>
          <div className="t-hidden group-hover:t-block">View</div>
        </Button>
      </div>
      <ActionItemEntitySelector
        {...entitySelector}
        entityList={entities.filter((entity) => item.ids.includes(entity.uuid))}
        setSelectedEntity={handleEntitySelect}
        context="cart"
      />

      {selectedEntity && (
        <CartModal
          open={cartPayment.isOpen}
          onClose={handleClose}
          entityIdFromProps={selectedEntity}
          groupIdFromProps={groupIdFromProps}
          hideEntitySelector
        />
      )}
    </>
  );
};
